import DeleteInvite from './DeleteInvite';
export default DeleteInvite;
